<template>
  <v-container class="pa-6">
    <div class="d-flex flex-row justify-space-between ">
      <h2>{{ pageTitle }}</h2>
      <v-btn
        v-track="'close-'+pageType+'-drawer'"
        class="ml-auto"
        icon
        @click="closeDrawer"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <p class="body-1 grey--text text--darken-2">
      {{subTitle}}
    </p>
    <v-col class="d-flex px-0" cols="7">
      <async-dropdown
        :select.sync="pageId"
        item-text="name"
        item-value="id"
        prop-to-search="name"
        responseKey="preference_pages"
        :customFilters="{ filter_by_page: pageType }"
        :append-default="[{ id: null, name: 'Default' }]"
        @onChange="loadPreview(preferencePageId, pageType)"
        :selectedItem="selectedItem"
        :get-records="fetchPreferencePages"
      ></async-dropdown>
          <v-btn
            v-track="`open-${pageType}-preview`"
            class="mt-2 mr-n3 ml-2"
            v-if="preferencePageId && isEditable"
            icon
            @click="navigateToEdit(selectedItem)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
    </v-col>
    <v-row no-gutters>
      <v-col>
        <iframe id="preview-content" :srcdoc="htmlContent" />
        <v-overlay :value="isLoading">
          <v-progress-circular indeterminate size="64" />
        </v-overlay>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { $preferencePages } from "@/services/";
import { mapGetters, mapMutations } from "vuex";
import { parsedHtml } from "../preference_management/previewRender";
import constants from '@/constants'
import { getSplitKey } from '@/splitClient';
import _ from "lodash";
export default {
  name: "PreviewDrawer",
  data() {
    return {
      isLoading: false,
      preferencePageId: null,
      preferencePages: [],
      editorType: "",
      previewContent: "",
      fetchPreferencePages: $preferencePages.fetch,
      pageNumber: 1,
      pageDetails: {},
      selectedItem:{id:null,name:'Default'},
      subTitle:''
    };
  },
  components: {
    AsyncDropdown : () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import('@/views/content/email/components/UIDAsyncDropdown.vue') : import('@/views/content/email/components/AsyncDropdown.vue')
  },
  computed: {
    ...mapGetters({
      drawer: "ui/drawer",
      account: "auth/account"
    }),
    pageTitle() {
      let pageType = this.pageType;
      if (pageType == "manage_subscriptions") {
        this.subTitle = 'This Preference Management page enables your contacts to update their subscription preference for the mailing lists.'
        return "Manage Subscription page preview";
      } else if (pageType == "edit_profile") {
        this.subTitle = 'This Preference Management page enables your contacts to edit their profile information.'
        return "Edit Profile page preview";
      } else if (pageType == "report_spam") {
        this.subTitle = 'This Preference Management page enables your contacts to report the email as spam.'
        return "Report Spam page preview";
      } else if (pageType == "one_click_unsubscribe") {
        this.subTitle = 'This Preference Management page enables your contacts to unsubscribe from all mailing lists with a 1 click.'
        return "1-Click Unsubscribe page preview";
      } else if (pageType == "confirm_subscription") {
        this.subTitle = ''
        return `Confirm Subscription page preview`;
      }  else {
        this.subTitle = ''
        return `${pageType} preview`;
      }
    },
    pageId: {
      get() {
        return this.preferencePageId
      },
      set(val) {
        this.preferencePageId = val;
      }
    },
    pageType() {
      return this.drawer.right.payloadData.pageType;
    },
    isEditable() {
      return this.drawer.right.payloadData.isEditable;
    },
    htmlContent(){
      return this.previewContent + "<style>body{ pointer-events:none}</style>"
    }
  },
  mounted() {
    this.preferencePageId = this.drawer.right.payloadData.pageId;
    if (!!this.pageId) {
      this.loadPreview(this.pageId, this.pageType);
    } else {
      this.loadDefaultPreview();
    }
  },
  methods: {
    ...mapMutations({
        drawerConfig: "ui/drawer.right"
    }),
    
    closeDrawer() {
      let config = {
        show: false,
        component: '',
        payloadData: {}
      }
      this.drawerConfig(config);
    },
    async loadPreview(pageId, pageType) {
      try {
        if (!!pageId) {
        let id;
        if (typeof pageId === "object") {
          id = pageId.id == null ? pageId.page_type : pageId.id;
        } else {
          id = pageId === null ? pageType : pageId;
        }
        this.isLoading = true;

        // Get the page details from api
        const res = await $preferencePages
          .fetchById(id, { params: { edit: true } })
          .catch(error => this.catch404Error(error));
        this.pageDetails = res.data.data.preference_page;
        this.selectedItem = res.data.data.preference_page;
        this.pageDetails.parsed_html_part = "";
        this.pageDetails.type = pageType;

        // Get the preview object and html part of the page and parse it
        const previewRes = await $preferencePages.preview(id);
        const previewObj = {
          ...previewRes.data.data.preference_page,
          preference_page: this.pageDetails
        };
        const content = parsedHtml(this.pageDetails.html_part, previewObj);
        this.previewContent = content;
        this.updateDrawerPayload(res.data.data.preference_page);
      } else {
        this.loadDefaultPreview();
      }
      } catch (error) {
        console.log({error})
      } finally {
        this.isLoading = false;
      }
    },
    navigateToEdit(page) {
      if (!page) return;
      if (this.pageType == "confirm_subscription") {
        this.$store.commit('acquisition/returnFromPreference', true)  
      } else {
        this.$store.commit('footer/returnToFooter', true)
      }
      if (this.drawer.right.payloadData.newTab) {
        const link = page.editor_type == "dnd" ?
          `/accounts/${this.account.id}/preference_pages/dndeditor/${page.id}/edit`
          : `/accounts/${this.account.id}/preference_pages/${page.id}/edit`;
        this.closeDrawer();
          window.open(link);
      } else {
        this.$router.push({
          name:
            page.editor_type == "dnd"
              ? "Preference_pages_dnd_editor"
              : "Preference_pages_editor",
          params: {
            pageId: page.id
          }
        });
      }
      
    },
    updateDrawerPayload(page) {
      this.$root.$emit("drawer:update-page", {
        ...this.drawer.right.payloadData,
        page
      });
    },
    async loadDefaultPreview() {
      try {
        this.isLoading = true;

        let res = await $preferencePages
          .getHtmlJsonPart({ params: { page_type: this.pageType } })
        const previewRes = await $preferencePages.preview(this.pageType);
        const previewObj = {
          ...previewRes.data.data.preference_page,
          preference_page: this.pageDetails
        };
        const content = parsedHtml(res.data.data.html_part, previewObj);
        this.previewContent = content;
        this.updateDrawerPayload({ id: null, name: "Default" });

      } catch (error) {
        console.log({ error })
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
<style scoped>
#preview-content {
  width: 100%;
  min-height: 64vh;
  border: 2px solid #eee;
}
</style>
